import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { AppAmplifyTokenService } from '@app/app-amplify-token.service';
import { UntilDestroy, UntilDestroyed } from './shared/utils/until-destroy';
import { TrackerEventsService } from './shared/services/tracker-events.service';
import { AuthorizeWithRingcentralService } from './shared/services/authorize-with-ringcentral.service';
import { LeadBoostService } from './lead-boost/services/lead-boost/lead-boost.service';
import {
  CompleteLeadAssignmentMutationVariables,
  NextLeadAssignmentResponseNode,
} from './generated/graphql';

@UntilDestroy()
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit {
  nextLeadAssignment$: Observable<NextLeadAssignmentResponseNode | null>;

  @ViewChild('authorizeRcTemplate') authorizeRcTemplate: TemplateRef<unknown>;

  constructor(
    private authorizeWithRingcentralService: AuthorizeWithRingcentralService,
    private appAmplifyTokenService: AppAmplifyTokenService,
    private trackerEventsService: TrackerEventsService,
    private leadBoostService: LeadBoostService,
  ) {}

  ngOnInit() {
    this.trackerEventsService.sendLoginEvent();
    this.appAmplifyTokenService.startTokenPolling().pipe(UntilDestroyed(this)).subscribe();

    this.nextLeadAssignment$ = this.leadBoostService.nextLeadAssignment$;
  }

  ngAfterViewInit() {
    this.authorizeWithRingcentralService.init(this.authorizeRcTemplate);
  }

  auth() {
    this.authorizeWithRingcentralService.auth();
  }

  completeLeadAssignment(params: CompleteLeadAssignmentMutationVariables) {
    this.leadBoostService.completeLeadAssignment(params);
  }
}
